import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getBrandFeaturesCorp } from '@ibe.components/corporate/flights/brand/brand';
import { BookedTrip, Flight } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import { BookingService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import * as fromStore from '../../../../store';

@Component({
	selector: 'app-corp-balance',
	templateUrl: './corp-balance.component.html',
	styleUrls: ['./corp-balance.component.scss']
})
export class CorpBalanceComponent implements OnInit {

	flight: Flight;
	flightIdentifier: string;

	// brand
	brandIdentifier: string;
	brand: string;

	feature: string;

	isAlive = true;

	booking_trip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booking_steps$: Observable<BookingStep[]> = this.store.select(fromStore.getSelectedBookingSteps);
	current_step$: Observable<number> = this.store.select(fromStore.getSelectedBookingCurrentStep);

	booking_trip: BookedTrip;

	hasChanges$: Observable<any> = combineLatest(
		this.route.params,
		this.booking_steps$,
		this.current_step$,
		this.booking_trip$,
	);

	bookingSteps: Array<BookingStep>;

	reviewFlights: boolean = false;
	timeToThinkFlights: boolean = false;

	constructor(
		private bookingService: BookingService,
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>
	) { }

	ngOnInit() {

		if (this.router.url.includes('/review-your-trip')) this.reviewFlights = true;
		if (this.router.url.includes('/time-to-think')) this.timeToThinkFlights = true;

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([route_params, booking_steps, current_step, booking_trip]) => {
				this.flightIdentifier = route_params.flight;
				this.booking_trip = booking_trip;

				this.flight = this.booking_trip.flights.filter(flight => flight.id === this.flightIdentifier)[0];

			if (route_params.brand)
				this.brandIdentifier = route_params.brand;
			else
				this.brandIdentifier = this.flight.options.brand;

			if (route_params.feature)
				this.feature = route_params.feature;
			else this.feature = 'corpbalance';
				console.log(getBrandFeaturesCorp(this.brandIdentifier));
				this.brand = Object.assign(getBrandFeaturesCorp(this.brandIdentifier).find(cur => cur.id == this.feature), { brand: this.brandIdentifier });

				if (!this.flight)
					this.bookingService
						.getFlight(booking_steps[current_step], route_params.flight, { step: current_step })
						.pipe(takeWhile(() => this.isAlive))
						.subscribe(
							res => {
								this.flight = Object.assign(new Flight(null, null, null), res, { options: { brand: this.brandIdentifier } });
							},
							error => console.error(error),
							() => { }
						);

			});
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	TAP_handleClose() {
		this.closeSidebar();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

}
